// @ts-nocheck

import TitleField from './system/title/title';
import StatusField from './system/status/status';
import PriorityField from './system/priority/priority';
import ScheduleField from './system/schedule/schedule';
import DeadlineField from './system/deadline/deadline';
import TaskTypeField from './system/task-type/task-type';
import AssignedToField from './system/assigned-to/assigned-to';
import DateCreatedField from './system/date-created/date-created';
import LastUpdatedField from './system/last-updated/last-updated';
import TaskIdField from './system/task-id';
import UsersField from './system/users/users';
import TagsField from './system/tags/tags';
import EstimateField from './system/estimate/estimate';
import EstimateFieldHours from "./system/estimate/estimate-hours";
import EstimateFieldMinutes from "./system/estimate/estimate-minutes";
import SpentEstimateField from "./system/spent-estimate/spent-estimate";
import ProgressBarField from './system/porgress-bar/progress-bar';
import ProgressItemsField from "./system/porgress-items/progress-items";
import ProgressAutoField from "./system/porgress-auto/progress-auto";
import TimeReportedField from './system/time-reported/time-reported';
import TimeReportedFieldHours from "./system/time-reported/time-reported-hours";
import TimeReportedFieldMinutes from "./system/time-reported/time-reported-minutes";
import CreatedByField from './system/created-by/created-by';
import ActionRequiredField from './system/action-required/action-required';
import StartDateField from './system/start-date/start-date';
import EndDateField from './system/end-date/end-date';
import StartEndDateField from './system/start-end-date/start-end-date';
import OwnerField from './system/owner/owner';
// import ProjectManagerField from './system/_old_to_remove_project-manager/project-manager';
import CommentsField from './system/comments/comments';
import OpenAllField from './system/open-all/open-all';
import ProjectColorField from './system/project-color/project-color';
import ProjectHealthField from './system/project-health/project-health';
import DurationCalendarDaysField from "./system/duration/duration-calendar-days";
import DurationWorkDaysField from "./system/duration/duration-work-days";
import ProjectField from "./system/project/project";
import ProjectFullNameField from "./system/project/project-full-name";
import DependsOnField from "./system/dependencies/depends-on";
import DependantsField from "./system/dependencies/dependants";
import DescriptionField from "./system/description/description";
import CostInternalField from "./system/cost/cost-internal";
import CostExternalField from "./system/cost/cost-external";
import CostExpensesField from "./system/cost/cost-expenses";
import DateClosedField from "./system/date-closed/date-closed";
import StoryPointsField from "./system/story-points/story-points";
import MessagesTotalField from "./system/total/messages/messages-total";
import AttachmentsTotalField from "./system/total/attachments/attachments-total";
import TodoField from "./system/todo/todo";

// Custom Fields
import NumberCustomField from './custom/number/number';
import StringCustomField from './custom/string/string';
import DateCustomField from './custom/date/date';
import CurrencyCustomField from './custom/currency/currency';
import PercentageCustomField from './custom/percentage/percentage';
import BooleanCustomField from './custom/boolean/boolean';
import ListCustomField from './custom/list/list';
import ListMultiCustomField from './custom/list-multi/list-multi';
import RatingCustomField from './custom/rating/rating';
import EmailCustomField from './custom/email/email';
import PhoneCustomField from './custom/phone/phone';
import UrlCustomField from './custom/url/url';
import UserCustomField from './custom/user/user';
import TextCustomField from './custom/text/text';
import RAGCustomField from './custom/rag/rag';
import FormulaCustomField from './custom/formula/formula';

// form fields
import FormFieldString from './form-field/string/string';
import FormFieldText from "./form-field/text/text";
import FormFieldNumber from "./form-field/number/number";
import FormFieldDropdown from "./form-field/dropdown/dropdown";
import FormFieldDate from "./form-field/date/date";

//generic
import GenericStringField from "./generic/string/string";
import FieldConverter21 from "../fields3/field-converter-2-1";
import UsersCustomField from "./custom/users/users";
import ProjectStatusCommentsField from "./system/project/project-status-comments";
import ColorCustomField from "./custom/color/color"
import ParentTaskField from "./system/parent-task/parent-task";
import CUSTOM_FIELDS_V1 from "../gd/const/fields/custom-fields-v1";
import FieldReaction from "../fields3/generic/reaction/reaction";
import {SessionCustomField} from "../gd-model/custom-field/gd-custom-field";
import FieldVoting from "../fields3/generic/voting/voting";
import FieldTimeOfDay from "../fields3/generic/datetime/time-of-day/time-of-day";
import FieldDatetime from "../fields3/generic/datetime/date-time/date-time";
import FieldToggle from "../fields3/generic/boolean/toggle/toggle";
import FieldAddress from "../fields3/generic/address/address";
import FieldAttachment from "../fields3/generic/attachment/attachment";

// const debug = "FieldsFactory"
const debug = false

export default class FieldsFactory1 {

    // entityType - for system entity type i.e. project or task status
    // for custom fields, customFieldId
    static get(field1Type, entityType = null, fieldConfig = null) {

        debug && console.log(debug, "get() field1Type=", field1Type, "entity=", entityType, "fieldConfig=", fieldConfig)

        switch (field1Type) {
            case gd.const.fields.type.TITLE:                    return new TitleField(entityType);
            case gd.const.fields.type.STATUS:                   return new StatusField(entityType);
            case gd.const.fields.type.PRIORITY:                 return new PriorityField(entityType);
            case gd.const.fields.type.SCHEDULE:                 return new ScheduleField(entityType);
            case gd.const.fields.type.DEADLINE:                 return new DeadlineField(entityType);
            case gd.const.fields.type.TASK_TYPE:                return new TaskTypeField(entityType);
            case gd.const.fields.type.ASSIGNED_TO:              return new AssignedToField(entityType);
            case gd.const.fields.type.DATE_CREATED:             return new DateCreatedField(entityType);
            case gd.const.fields.type.DATE_CLOSED:              return new DateClosedField(entityType);
            case gd.const.fields.type.LAST_UPDATED:             return new LastUpdatedField(entityType);

            case gd.const.fields.type.PROJECT:                  return new ProjectField(entityType);
            case gd.const.fields.type.PROJECT_FULL_NAME:        return new ProjectFullNameField(entityType);
            case gd.const.fields.type.PROJECT_STATUS_COMMENTS:  return new ProjectStatusCommentsField(entityType);

            //
            case gd.const.fields.type.TASK_ID:                  return new TaskIdField(entityType);
            case gd.const.fields.type.USERS:                    return new UsersField(entityType);
            case gd.const.fields.type.TAGS:                     return new TagsField(entityType);
            case gd.const.fields.type.ESTIMATE:                 return new EstimateField(entityType);
            case gd.const.fields.type.ESTIMATE_HOURS:           return new EstimateFieldHours(entityType);
            case gd.const.fields.type.ESTIMATE_MINUTES:         return new EstimateFieldMinutes(entityType);
            case gd.const.fields.type.PROGRESS_BAR:             return new ProgressBarField(entityType);
            case gd.const.fields.type.PROGRESS_ITEMS:           return new ProgressItemsField(entityType);
            case gd.const.fields.type.PROGRESS_PROJECT_TASKS:   return new ProgressAutoField(entityType);
            case gd.const.fields.type.TIME_REPORTED:            return new TimeReportedField(entityType);
            case gd.const.fields.type.TIME_REPORTED_HOURS:      return new TimeReportedFieldHours(entityType);
            case gd.const.fields.type.TIME_REPORTED_MINUTES:    return new TimeReportedFieldMinutes(entityType);
            case gd.const.fields.type.CREATED_BY:               return new CreatedByField(entityType);
            case gd.const.fields.type.ACTION_REQUIRED:          return new ActionRequiredField(entityType);
            case gd.const.fields.type.START_DATE:               return new StartDateField(entityType);
            case gd.const.fields.type.END_DATE:                 return new EndDateField(entityType);
            case gd.const.fields.type.START_END_DATE:           return new StartEndDateField(entityType);
            case gd.const.fields.type.DURATION_CALENDAR_DAYS:   return new DurationCalendarDaysField(entityType);
            case gd.const.fields.type.DURATION_WORK_DAYS:       return new DurationWorkDaysField(entityType);
            case gd.const.fields.type.SPENT_ESTIMATE:           return new SpentEstimateField(entityType);
            case gd.const.fields.type.DEPENDS_ON:               return new DependsOnField(entityType);
            case gd.const.fields.type.DEPENDANTS:               return new DependantsField(entityType);
            //
            case gd.const.fields.type.OWNER:                    return new OwnerField(entityType);
            // case gd.const.fields.type.PROJECT_MANAGER:          return new ProjectManagerField(entityType);
            case gd.const.fields.type.COMMENTS:                 return new CommentsField(entityType);
            case gd.const.fields.type.OPEN_ALL:                 return new OpenAllField(entityType);
            case gd.const.fields.type.PROJECT_COLOR:            return new ProjectColorField(entityType);
            case gd.const.fields.type.PROJECT_HEALTH:           return new ProjectHealthField(entityType);
            case gd.const.fields.type.DESCRIPTION:              return new DescriptionField(entityType);

            case gd.const.fields.type.COST_INTERNAL:            return new CostInternalField(entityType);
            case gd.const.fields.type.COST_EXTERNAL:            return new CostExternalField(entityType);
            case gd.const.fields.type.COST_EXPENSES:            return new CostExpensesField(entityType);

            case gd.const.fields.type.STORY_POINTS:             return new StoryPointsField(entityType);
            case gd.const.fields.type.MESSAGES_TOTAL:           return new MessagesTotalField(entityType);
            case gd.const.fields.type.ATTACHMENTS_TOTAL:        return new AttachmentsTotalField(entityType);

            case gd.const.fields.type.TODO_LIST:                return new TodoField(fieldConfig);
            case gd.const.fields.type.PARENT_TASK_ID:           return new ParentTaskField(fieldConfig);

            case gd.const.fields.type.GENERIC_STRING:           return new GenericStringField(fieldConfig);

            // this ones are used to deal with list/table specific things like aggregation and sorting
            // but actually it's stupid I think...
            case gd.const.fields.type.CRM_ACCOUNT:
            case gd.const.fields.type.CRM_CONTACT:
            case gd.const.fields.type.CRM_CONTACTS:
            case gd.const.fields.type.BASELINE:
            // case FieldType.ESTIMATED_COST_INTERNAL:
            // case FieldType.ESTIMATED_COST_EXTERNAL:
            // case FieldType.ITEM_MODEL_CALCULATED_EXPENSES:
                return FieldConverter21.getFieldByType(field1Type, entityType)

            //
            case gd.const.fields.type.CUSTOM_FIELD:
                debug && console.log(debug, "CF -> Custom Field")
                const customField = gd.session.customFields.get(entityType);

                if (!customField) {
                    debug && console.error(debug, 'Error #FF04: unknown custom field (' + entityType + ')');
                    return false;
                }
                return this._getCustomField(customField);

            default:
                debug && console.log(debug, "default -> Custom Field")

                // here field1Type - customFieldId in gd.session.customFields
                // const customFieldId : ID = field1Type

                // we expect custom field id (gd.session.customFields) here
                const customFieldObj : SessionCustomField = gd.session.customFields.get(field1Type);
                if (!customFieldObj) {
                    debug && console.error(debug, 'Error #FF03: unknown type (' + field1Type + ')');
                    return false;
                } else {
                    return this._getCustomField(customFieldObj);
                }
        }
    }

    static _getCustomField(customField : SessionCustomField) {

        debug && console.log(debug, "_getCustomField() customField=", customField)

        switch (customField.type) {
            case gd.const.customFields.type.NUMBER:         return new NumberCustomField(customField);
            case gd.const.customFields.type.STRING:         return new StringCustomField(customField);
            case gd.const.customFields.type.DATE:           return new DateCustomField(customField);
            case gd.const.customFields.type.CURRENCY:       return new CurrencyCustomField(customField);
            case gd.const.customFields.type.PERCENTAGE:     return new PercentageCustomField(customField);
            case gd.const.customFields.type.BOOLEAN:        return new BooleanCustomField(customField);
            case gd.const.customFields.type.LIST:           return new ListCustomField(customField);
            case gd.const.customFields.type.LIST_MULTI:     return new ListMultiCustomField(customField);
            case gd.const.customFields.type.RATING:         return new RatingCustomField(customField);
            case gd.const.customFields.type.EMAIL:          return new EmailCustomField(customField);
            case gd.const.customFields.type.PHONE:          return new PhoneCustomField(customField);
            case gd.const.customFields.type.URL:            return new UrlCustomField(customField);
            case gd.const.customFields.type.USER:           return new UserCustomField(customField);
            case gd.const.customFields.type.USERS:          return new UsersCustomField(customField);
            case gd.const.customFields.type.TEXT:           return new TextCustomField(customField);
            case gd.const.customFields.type.RAG:            return new RAGCustomField(customField);
            case gd.const.customFields.type.FORMULA:        return new FormulaCustomField(customField);
            case gd.const.customFields.type.COLOR:          return new ColorCustomField(customField);

            // case CUSTOM_FIELDS_V1.type.REACTION:            return new FieldReaction(customField); - wrong
            case CUSTOM_FIELDS_V1.type.REACTION             : return FieldReaction.initFromCustomFieldV1(customField)
            case CUSTOM_FIELDS_V1.type.VOTING               : return FieldVoting.initFromCustomFieldV1(customField)
            case CUSTOM_FIELDS_V1.type.TOGGLE               : return FieldToggle.initFromCustomFieldV1(customField)
            case CUSTOM_FIELDS_V1.type.ATTACHMENT           : return FieldAttachment.initFromCustomFieldV1(customField)
            case CUSTOM_FIELDS_V1.type.TIME_OF_DAY          : return FieldTimeOfDay.initFromCustomFieldV1(customField)
            case CUSTOM_FIELDS_V1.type.DATE_AND_TIME        : return FieldDatetime.initFromCustomFieldV1(customField)
            case CUSTOM_FIELDS_V1.type.ADDRESS              : return FieldAddress.initFromCustomFieldV1(customField)

            default:
                debug && console.error(debug, ': CFER-45 unknown custom field type (' + customField.type + ')');
                return false;
        }
    }

    // Form Fields = custom form fields i.e. request forms
    static getFormFieldByType(type, config={}) {
        switch (type) {
            case gd.const.formFields.type.STRING:           return new FormFieldString(config);
            case gd.const.formFields.type.TEXT:             return new FormFieldText(config);
            case gd.const.formFields.type.NUMBER:           return new FormFieldNumber(config);
            case gd.const.formFields.type.DROPDOWN:         return new FormFieldDropdown(config);
            case gd.const.formFields.type.DATE:             return new FormFieldDate(config);
            default:
                debug && console.error(debug, 'Error #FF01: unknown custom field type (' + type + ')');
                return false;
        }
    }
}
